import Vue from 'vue'
import Vuex from 'vuex'
import getters from '@/store/getters'
import actions from '@/store/actions'
import mutations from '@/store/mutations'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    location: null,
    locale: window.location.pathname.startsWith('/cn') ? 'cn' : 'en',

    programme: null,
    learning: null,
    journals: null,

    books: null,
    book: null,

    about: null,

    single: null,
    article: null,

    pages: {},

    featured: null,
    current: null,
    news: null,
    newsItem: null,

    visit: null,

    entities: {},

    searchTerm: null,
    searchResults: null,

    hasMedia: false,
    mute: true,

    closed: false,
    weather: null,

    style: {
      color: 'black',
      backgroundColor: 'white'
    },

    time: null,

    fromPage: null,
    fromLoc: null,
    firstVisit: false
  },
  getters,
  actions,
  mutations
})
